import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import MarkerMaps from './MarkerMaps';
import SpiLegend from './SpiLegend';
import PanelHeader from './PanelHeader';
import Error from './Error';
import ListMenu from './ListMenu';
import { getSpiPts } from './routines';

export default function Pcpn(props) {
	const { spiSaved, setSpiSaved, mode } = props;
	const [ panelError, setPanelError ] = useState(false);
	const [ mapspi, setMapspi ] = useState(spiSaved["mapspi"]);
	const [ showdm, setShowdm ] = useState(spiSaved["showdm"]);

	const selectedState = "vt";
	const prefix = mode === 'dev' ? "vt/" : "https://nedews.nrcc.cornell.edu/";
	const spiDataFile = prefix + "data/ne_spi.json";
	const buttonValue = null;
	const addtext = " ";
	const mapTitle = mapspi + ' SPI<br />' + spiSaved["date"];
	const spiList = ["30-day", "60-day", "90-day", "120-day"];

	useEffect(() => {
		setSpiSaved({...spiSaved, mapspi:mapspi});
		// eslint-disable-next-line
	}, [mapspi]);	
	
	useEffect(() => {
		setSpiSaved({...spiSaved, showdm:showdm});
		// eslint-disable-next-line
	}, [showdm]);

	useEffect(() => {
		if (!spiSaved["markers"]) {
			getSpiPts(spiDataFile, spiSaved, setSpiSaved, setPanelError);
		}
		// eslint-disable-next-line
	}, []);

	return (
		<>
			{!panelError &&
				<>
					<PanelHeader
						title={"Precipitation Summary"}
						addtext={addtext}
						buttonValue={buttonValue}
						showdm={showdm}
						setShowdm={setShowdm}	
					/>
					{spiSaved["markers"] &&
						<>
							<div tabIndex={-1} className="mapandlegend-container">
								<MarkerMaps 
									selectedState={selectedState} 
									markers={spiSaved["markers"][mapspi]} 
									mapTitle={mapTitle}
									geo="towncounty"
									usdmOverlay={showdm} 
									mode={mode}
									/>
								<SpiLegend />
								<ListMenu
									selected={setMapspi}
									list={spiList}
									title="Change SPI"
								/>
							</div>
						</>
					}
					{!spiSaved["markers"] &&
						<>
							<CircularProgress /> 
							<Typography display="inline" sx={{p:1}}>Loading</Typography>
						</>
					}
				</>
			}
			{panelError &&
				<Error />
			}
	   </>
	);
}